import { useEffect } from "@wordpress/element";

export default function RegistrationTable({loadingState, response, redirect}) {

    useEffect(() => {}, [loadingState, response]);

    const hasItems = Array.isArray(response?.items) && response.items.length > 0;

    return (
        <div className="block w-full p-6 bg-white border border-gray-200 rounded-lg shadow-sm registration-table">
                <div class="flex items-baseline justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 bg-white">
                    <div className="flex items-baseline">
                        <h3 className="component-heading">Recent Registration Requests</h3>
                        &nbsp;&nbsp;
                        {loadingState ? <div class="h-4 bg-gray-200 rounded" style={{ width: '6rem' }}></div> : <span class="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full">{response?.pending}</span> }

                    </div>
                </div>
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left rtl:text-right">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Name
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Email
                            </th>
                            <th scope="col" class="px-6 py-3">
                                User Role
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Date
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    { ! loadingState ? (
                            hasItems ? response.items.map(item => (
                            <tr class="bg-white border-b border-gray-200 hover:bg-gray-50">
                                <td class="px-6 py-4 underline">
                                    {item.name}
                                </td>
                                <td class="px-6 py-4">
                                    {item.email}
                                </td>
                                <td class="px-6 py-4">
                                    <div class="flex items-center">
                                        {item.role}
                                    </div>
                                </td>
                                <td class="px-6 py-4">
                                    {item.date}
                                </td>
                                <td class="px-6 py-4">
                                    <span class={`text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm 
                                        ${item?.status == 'Active'
                                            ? 'bg-green-100 text-green-800'
                                            : item?.status == 'Waiting'
                                            ? 'bg-yellow-100 text-yellow-800'
                                            : item?.status == 'Rejected'
                                            ? 'bg-red-100 text-red-800'
                                            : 'bg-gray-100 text-gray-800'}`}>{item.status}</span>
                                </td>
                            </tr>
                        )) : (
                            <tr class="bg-white border-b border-gray-200">
                                <td class="px-6 py-4 text-center text-sm text-gray-500" colSpan="6">
                                    No registration requests found for this period.
                                </td>
                            </tr>
                        )) : (
                            <Skeleton />
                        )}
                    </tbody>
                </table>
                <div className="w-full text-center bg-gray-50 px-6 py-3 text-sm"><a href={redirect}>View Full Table</a></div>
            </div>
        </div>
    );
}

function Skeleton() {
    return (
        <>
        {[...Array(5)].map((_, i) => (
            <tr class="bg-white border-b border-gray-200 animate-pulse">
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-32"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-40"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-28"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-5 bg-gray-200 rounded w-20"></div>
                </td>
            </tr>
        ))}
    </>
    );
}